import { defineMessages } from "react-intl";

export const messages = defineMessages({
  inviteBtn: {
    id: "dashboardview.profilecard.invitebtn",
    defaultMessage: "Invite to meeting",
    description: "button text for inviting to a meeting",
  },
});
